<template>
  <loader
    v-if="!profileId || loading"
    :class="$style.loader"
  />
  <div
    v-else
    :class="$style.card"
  >
    <div :class="$style.buttonsContainer">
      <button
        :class="[$style.addUserButton, $style.buttonContainer]"
        @click="openModal"
      >
        {{ $t('settings.addRequest') }}
      </button>
    </div>
    <dragTreeTable
      :class="$style.dragTreeTable"
      :data="treeData"
      :height-row="true"
      @deleteItem="deleteItem"
      @editItem="editItem"
    />

    <add-sec-rule
      v-if="isViewModal"
      :class="$style.modal"
      :data="treeData.lists"
      :item="currentItem"
      :is-delete="isDelItem"
      @update="updateTreeData"
      @close="closeModal"
    />
  </div>
</template>

<script>
  import { getSecRules } from '@/api/methods/settings';
  import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import AddSecRule from './add-sec-rule.vue';

  export default {
    components: {
      dragTreeTable,
      AddSecRule,
      Loader,
    },
    data() {
      return {
        loading: false,
        isViewModal: false,
        currentItem: null,
        isDelItem: false,
        unsubscribeActions: [],
        initData: [],
        treeData: {
          columns: [
            {
              title: this.$t('settings.columns.comment'),
              field: 'comment',
              maxWidth: '20%',
              height: 'auto',
              padding: '5px',
              align: 'left',
              flex: 1,
            },
            {
              title: this.$t('settings.columns.queryText'),
              field: 'queryText',
              maxWidth: '100%',
              height: 'auto',
              padding: '5px',
              align: 'left',
              flex: 1,
            },
            {
              type: 'action',
              title: this.$t('settings.columns.action'),
              maxWidth: '10%',
              padding: '5px',
              align: 'left',
              flex: 1,
              actions: [
                {
                  text: this.$t('settings.columns.actions.changeName'),
                  eventName: 'editItem',
                  formatter: () => '',
                },
                {
                  text: this.$t('settings.columns.actions.deleteItem'),
                  eventName: 'deleteItem',
                  formatter: () => '',
                },
              ],
            },
          ],
          lists: [],
          custom_field: {
            id: 'ident',
            lists: 'children',
            parent_id: 'category',
          },
        },
      };
    },
    computed: {
      profileId() {
        return this.$store.getters['settings/profile'];
      },
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
    },
    watch: {
      profileId: {
        async handler(newVal) {
          if (newVal) await this.getSecRulesData(newVal);
        },
        immediate: true,
      },
    },
    mounted() {
      this.unsubscribeActions.push(
        this.$store.subscribeAction({
          after: async (action) => {
            if (action.type === 'settings/cancel') {
              this.treeData.lists = this.initData;
            }
          },
        }),
        this.$store.subscribeAction({
          after: async (action) => {
            if (action.type === 'settings/paramChanged') {
              this.initData = this.treeData.lists;
            }
          },
        }),
      );
    },

    beforeDestroy() {
      this.unsubscribeActions.forEach((unsubscribe) => unsubscribe());
    },
    methods: {
      openModal() {
        this.isViewModal = true;
      },
      closeModal() {
        this.isViewModal = false;
        this.currentItem = null;
        this.isDelItem = false;
      },
      deleteItem(event) {
        this.currentItem = event;
        this.isDelItem = true;
        this.openModal();
      },
      async getSecRulesData(profileId) {
        try {
          this.treeData.lists = [];
          this.loading = true;
          const { data } = await getSecRules(profileId);
          if (data?.success) {
            this.treeData.lists = data.result;
            this.initData = data.result;
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
      updateTreeData(events) {
        this.treeData.lists = events;
        this.closeModal();
      },

      editItem(item) {
        this.currentItem = item;
        this.openModal();
      },
    },
  };
</script>

<style lang="scss" module>
  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    height: 100%;
    padding: 5px;
    > :not(:last-child) {
      border-bottom: 0.2px solid #eee;
    }
  }

  .dragTreeTable {
    height: calc(100vh - 540px);
  }

  .buttonsContainer {
    display: inline-flex;
    margin-bottom: 10px;
  }

  .buttonContainer {
    width: 50%;
  }

  .addUserButton {
    border: 1px solid white;
    background: #2985bf;
    cursor: pointer;
    height: 30px;
    color: white;
    width: 100%;
  }

  .modal {
    display: flex;
    z-index: 3000;
  }
</style>
